import Marquee from "react-fast-marquee";

const ITEMS = [
  "Local & Cross-Country",
  "Elderly & Medical Transport",
  "Mental Health Service Transport",
  "Sprinter Van Delivery",
  "NGO & Provider Partnerships",
];

export default function BrandMarquee() {
  return (
    <div className="bg-ink-2 border-y border-gold/15 py-6" data-testid="brand-marquee">
      <Marquee speed={38} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl sm:text-4xl text-gold/70 px-8">{item}</span>
            <span className="text-gold text-xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
